import { render, staticRenderFns } from "./NewsSingleMore.vue?vue&type=template&id=d436264a&"
import script from "./NewsSingleMore.vue?vue&type=script&lang=js&"
export * from "./NewsSingleMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports